
import { Card } from "@/components/ui/card";
import { format } from "date-fns";

interface Review {
  id: string;
  rating: number;
  comment?: string;
  created_at: string;
  meal?: {
    name: string;
  };
  user?: {
    first_name: string;
    last_name: string;
  };
}

interface ReviewsSectionProps {
  reviews: Review[] | undefined;
  isLoading: boolean;
}

export const ReviewsSection = ({ reviews, isLoading }: ReviewsSectionProps) => {
  if (isLoading) {
    return (
      <div className="flex justify-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
      </div>
    );
  }

  if (!reviews?.length) {
    return (
      <Card className="p-6 text-center text-black">
        No reviews yet
      </Card>
    );
  }

  return (
    <div className="space-y-4">
      {reviews.map((review) => (
        <Card key={review.id} className="p-4">
          <div className="space-y-2">
            <div className="flex justify-between items-start">
              <div>
                <p className="font-medium text-black">{review.meal?.name}</p>
                <p className="text-sm text-black">
                  by {review.user?.first_name} {review.user?.last_name}
                </p>
              </div>
              <div className="flex items-center gap-1">
                <span className="font-medium text-black">{review.rating}</span>
                <span className="text-yellow-400">★</span>
              </div>
            </div>
            {review.comment && (
              <p className="text-sm text-black">{review.comment}</p>
            )}
            <p className="text-xs text-black">
              {format(new Date(review.created_at), 'MMM d, yyyy')}
            </p>
          </div>
        </Card>
      ))}
    </div>
  );
};
